/**
 * WEB-10: счётчик непрочитанного в шапке кабинета.
 *
 * 🔴 Смысл кнопки — не украшение, а ответ на вопрос владельца «человек зашёл в
 * чат, а мне-то как туда попасть?». Поэтому она:
 * - видна с ЛЮБОЙ страницы кабинета (живёт в каркасе);
 * - ведёт СРАЗУ в переписку, если непрочитанное ровно у одного человека, и в
 *   список участников, если их несколько, — лишний перебор вкладок и был тем,
 *   из-за чего 25.08 пять сообщений остались непрочитанными;
 * - несёт тумблер уведомлений (WEB-24): прежняя кнопка WEB-10 лишь спрашивала
 *   разрешение и работала, пока вкладка открыта; теперь тем же нажатием
 *   оформляется подписка, доходящая и при закрытом браузере.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
// WEB-17: значение, а не хук. Опрос сервера теперь один на весь каркас — иначе
// шапка и меню спрашивали бы порознь и показывали разные числа.
import { useUnreadValue } from '../../../msg/unreadContext';
import PushToggle from '../../../msg/pushToggle';

const label = (n) => (n > 99
  ? '99+ новых'
  : `${n} ${(n % 10 === 1 && n % 100 !== 11) ? 'новое' : 'новых'}`);

const UnreadBell = () => {
  const { enabled, members, room, total } = useUnreadValue();
  const navigate = useNavigate();

  if (!enabled) return null;

  const withUnread = members.filter((m) => (m.unread ?? 0) > 0);
  const roomUnread = room?.unread ?? 0;
  /**
   * Куда вести. 🔴 Смысл кнопки — попасть в разговор ОДНИМ нажатием: ждёт
   * ровно одно место — открываем его, ждёт несколько — список.
   */
  const open = () => {
    if (roomUnread > 0 && withUnread.length === 0) { navigate('/msg/room'); return; }
    navigate(withUnread.length === 1 && roomUnread === 0
      ? `/msg/m/${withUnread[0].id}` : '/msg/invite');
  };
  const title = () => {
    if (roomUnread > 0 && withUnread.length === 0) return `Общий чат: ${label(roomUnread)}`;
    if (roomUnread === 0 && withUnread.length === 1) {
      return `${withUnread[0].display_name}: ${label(total)}`;
    }
    return `${label(total)}`;
  };

  return (
    <div className="cabinetUnread">
      {total > 0 && (
        <button
          type="button"
          className="cabinetIconButton cabinetUnreadButton"
          onClick={open}
          data-testid="unread-bell"
          aria-label={`Непрочитанные сообщения: ${label(total)}`}
          title={title()}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
               aria-hidden="true" focusable="false">
            <path d="M18 8a6 6 0 1 0-12 0c0 7-3 8-3 8h18s-3-1-3-8" />
            <path d="M13.7 21a2 2 0 0 1-3.4 0" />
          </svg>
          <span className="cabinetUnreadCount" aria-hidden="true">
            {total > 99 ? '99+' : total}
          </span>
        </button>
      )}
      {/* WEB-24: на месте прежней кнопки WEB-10 — настоящая подписка.
          🔴 Та лишь спрашивала разрешение и работала, пока вкладка ОТКРЫТА:
          закрыл браузер — не узнал ничего, и это ровно та беда, о которой
          владелец сказал 05.09. Разрешение тумблер спрашивает сам (тем же
          `Notification.requestPermission`), поэтому прежнее поведение он не
          теряет, а дополняет. */}
      <PushToggle variant="header" testId="cabinet-push" />
    </div>
  );
};

export default UnreadBell;
